import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppVersionComponent } from '@shared/components/app-version/app-version';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, AppVersionComponent],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  protected title = 'foodorderingapplicationweb';
}
